import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AppAlertService } from '../../services/app-alert/app-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../../services/app-message/app-message.service';
import { FormGroup } from '@angular/forms';
import { ParameterService } from '../../services/parameter/parameter.service';

@Component({
  selector: 'app-email-list',
  templateUrl: './email-list.component.html',
  styleUrl: './email-list.component.scss',
})
export class EmailListComponent implements OnInit, OnChanges {
  @ViewChild('emailInput') emailInput!: ElementRef;
  @Output() emailItemsChange = new EventEmitter<any[]>();
  @Input() emails: any[] = [];
  @Input() types: any[] = [];
  @Input() title:string | null=null;
  @Input() form:FormGroup;
  @Input() isSubmit:boolean=false;
  @Input() isReadOnly=false
  @Input() patientEmails?:number=0;
  emailItems: Array<any> = [];
  newEmailItem: boolean = false;
  newEmailData: any = {
    type: null,
    name: '',
    prefixValue: '',
    phone: '',
    relativePhone: '',
    email: '',
    priority: false,
  };
  selectedRow: any;
  editingIndex: number | null = null;
  activeTooltipIndex: number | null = null;
  tooltipPosition = { x: 0, y: 0 };
  @Input() showSearchIcon: boolean = false;
  @Output() searchClicked = new EventEmitter<void>();

  newHeadItem() {
    this.cancel();
    const defaultType = this.types.find((t) => t.default === true);
    this.newEmailItem = !this.newEmailItem;
    if (this.emailItems && this.emailItems.length > 0) {
      this.newEmailData = {
        type: defaultType,
        name: '',
        prefixValue: '',
        relativePhone: '',
        phone: '',
        email: '',
        priority: false,
      };
    } else {
      this.newEmailData = {
       type: defaultType,
        name: '',
        prefixValue: '',
        relativePhone: '',
        phone: '',
        email: '',
        priority: true,
      };
    }
     setTimeout(() => {
    this.emailInput?.nativeElement?.focus();
  }, 0);
  }

  constructor(
    private readonly appAlertService: AppAlertService,
    private readonly translate: TranslateService,
    private readonly messageService: AppMessageService,
    private readonly parameterService: ParameterService,
  ) {}

  ngOnInit() {
    this.parameterService
      .getParameterValues('data-group', 'email-types')
      .subscribe((res) => {
        this.types = res?.datas?.values.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
            default: data?.valueObject?.default?.value,
          };
        });

        
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['emails']?.currentValue) {
      const emails =
        changes['emails'].currentValue?.length > 0
          ? changes['emails'].currentValue
          : [];

      this.emailItems = emails?.map((item: any) => {
        return {
          ...item,
          type: item?.type?.valueObject
            ? {
                label: item?.type?.valueObject?.name?.value,
                value: item?.type?.valueObject?.id?.value,
              }
            : {
                label:
                  this.types.find((t) => t.value === item?.type)?.label || '',
                value: item?.type || null,
              },
        };
      });
    }
  }

  onClickSearchIcon() {
    this.searchClicked.emit();
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  isAddValid(): boolean {
    return (
      this.isValidEmail(this.newEmailData.email) &&
      this.newEmailData.type?.value
    );
  }

  cancel() {
    this.selectedRow = null;
    this.editingIndex = null;
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  edit(item: any, index: number) {
    this.editingIndex = index;
    this.selectedRow = { ...item };
    this.hideTooltip();
  }

  add() {
  const newEmail = { ...this.newEmailData };

  if (this.emailItems.length === 0) {
    newEmail.priority = true;
    this.completeAdd(newEmail);
    this.newEmailItem = false; // ✅ formu kapat
    return;
  }

  if (newEmail.priority) {
    this.appAlertService.sweetConfirm({
      header: this.translate.instant('shared-components.email-priority'),
      message: this.translate.instant('shared-components.priority-change-confirm'),
      showCloseButton: true, 
      accept: () => {
        for(const item of this.emailItems){
          item.priority = false
        }
        this.completeAdd(newEmail);
        this.newEmailItem = false; // ✅ sadece kullanıcı onay verirse kapat
      },
      reject: () => {
        // Kullanıcı iptal ederse form açık kalabilir veya istersen kapatabilirsin:
        // this.newEmailItem = false;
      },
    });
  } else {
    this.completeAdd(newEmail);
    this.newEmailItem = false; // ✅ burada da kapat
  }
}


  completeAdd(newEmail: any) {
    this.emailItems.push(newEmail);
    this.newEmailData = {
      type: { label: '', value: null },
      name: '',
      prefixValue: '',
      relativePhone: '',
      phone: '',
      email: '',
      priority: false,
    };

    const emailDataToEmit = this.emailItems.map((item: any) => {
      return {
        ...item,
        type: item?.type?.value,
      };
    });
    this.emailItemsChange.emit(emailDataToEmit);
  }

  deleteItem(index: number): void {
    this.hideTooltip();
    this.emailItems.splice(index, 1);
    this.emailItemsChange.emit(this.emailItems);
  }

  saveItem() {
    if (this.editingIndex !== null) {
      const priorityCount = this.emailItems.filter(item => item.priority).length;

      // ✅ Eğer priority false -> true'ya değişecekse sweetConfirm göster
      if (
        this.selectedRow.priority === true &&
        this.emailItems[this.editingIndex].priority === false
      ) {
        this.appAlertService.sweetConfirm({
          header: this.translate.instant('shared-components.email-priority'),
          message: this.translate.instant('shared-components.priority-change-confirm'),
          showCloseButton: true, 
          accept: () => {
            for(const [emailItem, i] of this.emailItems){
              if (i !== this.editingIndex) {
                emailItem.priority = false;
              }
            }
            this.completeSave();
          },
          reject: () => {
            this.cancel();
          }
        });
        return; // ✅ SweetConfirm sonrası devam etmesini engelle
      }

      // Eğer priority kaldırılacaksa ve listede sadece 1 tane varsa uyarı göster
      if (
        this.selectedRow.priority === false &&
        this.emailItems[this.editingIndex].priority === true &&
        priorityCount === 1
      ) {
        this.messageService.infoToast(
          this.translate.instant('shared-components.priority-required'),
          this.translate.instant('shared-components.one-priority-email'),
        );
        return;
      }
    }


   if(this.editingIndex!==null){
    const priorityCount = this.emailItems.filter(item => item.priority).length;
     // Eğer seçilen satır priority ise ve birden fazla telefon varsa sweetConfirm göster
    if (this.selectedRow.priority && priorityCount ===1 && this.emailItems[this.editingIndex].priority === false) {
      this.appAlertService.sweetConfirm({
        header: this.translate.instant('shared-components.email-priority'),
        message: this.translate.instant('shared-components.priority-change-confirm'),
        showCloseButton: true, 
        accept: () => {
          for(const [emailItem, i] of this.emailItems){
            if (i !== this.editingIndex) {
              emailItem.priority = false;
            }
          }
          this.completeSave();
        },
        reject: () => {
          this.cancel();
        }
      });
    } else {
      this.completeSave();
    }
   }
  }

  completeSave() {
    if (this.editingIndex !== null) {
      this.emailItems[this.editingIndex] = { ...this.selectedRow };
    }

    const emailDataToEmit = this.emailItems.map((item: any) => {
      return {
        ...item,
        type: item?.type?.value,
      };
    });
    this.emailItemsChange.emit(emailDataToEmit);
    this.selectedRow = null;
    this.editingIndex = null;
  }

  showTooltip(index: number, event: MouseEvent) {
    this.activeTooltipIndex = index;
    this.tooltipPosition = { x: event.clientX + 10, y: event.clientY + 10 }; // Tooltip'in fare pozisyonuna göre konumlandırılması
  }

  hideTooltip() {
    this.activeTooltipIndex = null;
  }
}
